import { useUserSessions } from '../hooks';
import { TableSkeleton } from '../components/LoadingSkeleton';
import { EmptyState, ErrorState } from '../components/EmptyState';

export function DevicesTab({ userId }: { userId: string }) {
  const { data, isLoading, isError, error, refetch } = useUserSessions(userId);
  if (isLoading) return <TableSkeleton rows={3} cols={4} />;
  if (isError) return <ErrorState message={(error as Error).message} onRetry={() => void refetch()} />;
  if (!data || data.length === 0)
    return <EmptyState title="No active devices" hint="The user has no recorded sessions." />;

  return (
    <ul className="space-y-2">
      {data.map((s) => (
        <li key={s.id} className="glass-panel rounded-lg p-3 flex justify-between items-center">
          <div>
            <div className="font-bold text-sm">{s.deviceName ?? 'Unknown device'}</div>
            <div className="text-[11px] text-on-surface-variant break-all">{s.userAgent ?? '—'}</div>
            <div className="text-[11px] text-on-surface-variant">{s.ipAddress ?? '—'}</div>
          </div>
          <div className="text-right">
            <div className="text-[11px] text-on-surface-variant">
              {s.isActive ? 'Active' : 'Revoked'}
            </div>
            <div className="text-[10px] text-on-surface-variant">
              {new Date(s.lastActive).toLocaleString('en-IN')}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
